import { render, staticRenderFns } from "./AmazonPayButton.vue?vue&type=template&id=5f0a40b7&scoped=true&lang=pug&"
import script from "./AmazonPayButton.vue?vue&type=script&lang=js&"
export * from "./AmazonPayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a40b7",
  null
  
)

export default component.exports